import { Fragment, useState } from "react";
import { Link } from "react-router-dom";

const norm = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const handle = (m) => m.username || m.display_name;

export const memberPath = (leagueId, id) => `/ligues/${leagueId}/membre-${id}`;

export function MentionText({ text, mentions, leagueId }) {
  if (!text) return null;
  const byName = {};
  (mentions || []).forEach((m) => { [m.username, m.display_name].filter(Boolean).forEach((n) => { byName[n] = m.id; }); });
  const names = Object.keys(byName).sort((a, b) => b.length - a.length);
  if (!names.length) return text;
  const parts = text.split(new RegExp(`(@(?:${names.map(escapeRe).join("|")}))`, "g"));
  return parts.map((p, i) => {
    const id = p.startsWith("@") && byName[p.slice(1)];
    if (!id) return <Fragment key={i}>{p}</Fragment>;
    return leagueId
      ? <Link key={i} to={memberPath(leagueId, id)} className="font-semibold text-[#B7F52A] hover:underline" data-testid="mention-chip">{p}</Link>
      : <b key={i} className="font-semibold text-[#B7F52A]" data-testid="mention-chip">{p}</b>;
  });
}

export function useMentions(members, meId) {
  const [picked, setPicked] = useState([]);
  const [query, setQuery] = useState(null);
  const [active, setActive] = useState(0);
  const options = query === null ? [] : members.filter((m) => m.id !== meId && (norm(m.display_name).includes(norm(query)) || norm(m.username || "").includes(norm(query)))).slice(0, 6);
  const track = (value, caret) => {
    const m = value.slice(0, caret).match(/(?:^|\s)@([^\s@]{0,20})$/);
    setQuery(m ? m[1] : null);
    setActive(0);
  };
  const choose = (m, text, el, setText) => {
    const caret = el.selectionStart;
    const before = text.slice(0, caret).replace(/@([^\s@]{0,20})$/, `@${handle(m)} `);
    setText(before + text.slice(caret));
    setPicked((p) => [...p.filter((x) => x.id !== m.id), m]);
    setQuery(null);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(before.length, before.length); });
  };
  const ids = (text) => picked.filter((m) => new RegExp(`@${escapeRe(handle(m))}(?![A-Za-z0-9_])`).test(text)).map((m) => m.id);
  const reset = () => { setPicked([]); setQuery(null); };
  const add = (m) => setPicked((p) => [...p.filter((x) => x.id !== m.id), m]);
  return { options, active, setActive, track, choose, ids, reset, add, close: () => setQuery(null) };
}

export function MentionList({ options, active, onPick, testId, up }) {
  if (!options.length) return null;
  return (
    <ul role="listbox" aria-label="Membres à mentionner" className={`absolute left-0 z-50 w-64 max-w-[80vw] overflow-hidden rounded-xl border border-white/10 bg-[#131B30] shadow-2xl ${up ? "bottom-full mb-1" : "top-full mt-1"}`} data-testid={`${testId}-mentions`}>
      {options.map((m, i) => (
        <li key={m.id} role="option" aria-selected={i === active}>
          <button type="button" onMouseDown={(e) => { e.preventDefault(); onPick(m); }} data-testid={`${testId}-mention-${m.id}`}
            className={`flex w-full items-center gap-2 px-3 py-2.5 text-left text-sm ${i === active ? "bg-[#B7F52A]/15 text-white" : "text-slate-200 hover:bg-white/5"}`}>
            <span className="text-[#B7F52A]">@</span>{handle(m)}{m.username && <span className="ml-auto truncate text-xs text-slate-400">{m.display_name}</span>}
          </button>
        </li>
      ))}
    </ul>
  );
}
